module.exports = __webpack_public_path__ + "media/new-message.a90b8d5c.mp3";